export const dotSyntaxResolver = (path: string, obj: object) => {
  return path.split('.').reduce((acc: any, curr: string) => {
    return acc ? acc[curr] : null;
  }, obj);
};

export const hasError = (name: string, errors: any, disabled: boolean) => {
  return !!dotSyntaxResolver(name, errors) && !disabled;
};

export const extractErrorMessages = (obj: any, arr: string[]) => {
  const keys = Object.keys(obj);
  if (keys.includes('message')) {
    arr.push(obj['message']);
  } else {
    for (const property in obj) {
      if (obj.hasOwnProperty(property)) {
        if (typeof obj[property] == 'object') {
          extractErrorMessages(obj[property], arr);
        }
      }
    }
  }
};

export const extractFirstErrorMessage: (obj: any) => string | undefined = (obj: any) => {
  const keys = Object.keys(obj);
  if (keys.includes('message')) {
    return obj['message'];
  } else {
    for (const property in obj) {
      if (obj.hasOwnProperty(property)) {
        if (typeof obj[property] == 'object') {
          return extractFirstErrorMessage(obj[property]);
        }
      }
    }
  }
};

export const extractReportsErrors = (obj: any, arr: string[]) => {
  let key: keyof typeof obj;
  for (key in obj) {
    const v = obj[key];
    if (v.length) {
      for (let i = 0; i < v.length; i++) {
        arr.push(v[i].reason);
      }
    }
  }
};
